// src/shared/components/IconButton.jsx
import React from 'react';
import PropTypes from 'prop-types';

export default function IconButton({
  type = 'button',
  onClick,
  disabled = false,
  children,
  icon,
  iconPosition = 'end',
  className = 'btn btn-primary',
}) {
  return (
    <button
      type={type}
      className={`${className} d-flex align-items-center justify-content-center gap-2`}
      onClick={onClick}
      disabled={disabled}
    >
      {icon && iconPosition === 'start' && <i className={`bi ${icon} me-1`} />}
      {children}
      {icon && iconPosition === 'end' && <i className={`bi ${icon} ms-1`} />}
    </button>
  );
}

IconButton.propTypes = {
  type: PropTypes.string,
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
  children: PropTypes.node.isRequired,
  icon: PropTypes.string,
  iconPosition: PropTypes.oneOf(['start', 'end']),
  className: PropTypes.string,
};

